import { Store, Module, ActionContext } from 'vuex'
import Config from '../entities/config'
import Ajax from '../../lib/ajax'

interface ConfigState {
    loading: boolean,
    editConfig: Config,
    list: Config[]
}
class ConfigModule implements Module<ConfigState, Config>{
    namespaced=true;
    state = <ConfigState>{
        list: new Array<Config>(),
        loading: false,
        editConfig: new Config()
    }
    actions = {
        async getAll(context: ActionContext<ConfigState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/Configuration/GetAll?template=Template');
            context.state.loading = false;
            context.state.list = reponse.data.result as Array<Config>;
        },
        async create(context: ActionContext<ConfigState, any>, payload: any) {
            await Ajax.post('/api/services/app/Configuration/Create', payload.data);
        },
        async update(context: ActionContext<ConfigState, any>, payload: any) {
            await Ajax.put('/api/services/app/Configuration/Update', payload.data);
        },
        async delete(context: ActionContext<ConfigState, any>, payload: any) {
            await Ajax.delete('/api/services/app/Configuration/Delete?Id=' + payload.data.id);
        },
    };
    mutations = {
        edit(state: ConfigState, config: Config) {
            state.editConfig = config;
        }
    }
}

const module = new ConfigModule();
export default module;